<template>
  <v-container class="fill-height text-center" fluid>
    <v-container fluid>
      <!-- SIGN-IN -->
      <div class="center-center" v-show="form != 'register'">
        <transition name="fade">
          <v-alert
            v-if="notification.show"
            :color="notification.color"
            :dark="notification.dark"
            :icon="notification.icon"
            dismissible
            dense
          >
            <div v-if="notification.title" class="text-h6">
              {{ notification.title }}
            </div>
            {{ notification.message }}
          </v-alert>
        </transition>
        <v-card
          class="elevation-0 signin-wrapper"
          :class="{ register: form == 'register' }"
        >
          <v-card-title>
            <v-spacer></v-spacer>
            <h2>{{ $t("ATX CMS") }}</h2>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-subtitle>AUTHENTICATION</v-card-subtitle>

          <v-card-text class="pb-0">
            <v-tabs-items v-model="form">
              <!-- SIGN IN FORM -->
              <v-tab-item id="signin">
                <v-card class="">
                  <v-card-text>
                    <v-form ref="siginInForm" v-model="valid">
                      <v-text-field
                        class="input-center"
                        label="E-mail"
                        name="email"
                        v-model="email"
                        :rules="[rules.emailRequired, rules.emailValid]"
                        required
                        validate-on-blur
                        filled
                        rounded
                      ></v-text-field>
                      <!-- v-model="email" -->
                      <v-text-field
                        class="input-center"
                        label="Enter Password"
                        v-model="password"
                        name="Password"
                        :type="passwordShow ? 'text' : 'password'"
                        :rules="[rules.required, rules.min]"
                        :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="passwordShow = !passwordShow"
                        v-on:keyup.enter="signIn"
                        filled
                        rounded
                      ></v-text-field>
                      <!-- v-model="password" -->
                      <v-btn
                        color="blue-grey lighten-3"
                        class="mr-4"
                        dark
                        @click="$refs.siginInForm.reset()"
                      >
                        CLEAR
                      </v-btn>

                      <v-btn
                        :disabled="!valid"
                        :dark="valid"
                        color="indigo darken-2"
                        @click="signIn"
                      >
                        SIGN IN
                      </v-btn>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!-- RESET PASSWORD FORM -->
              <v-tab-item id="resetPassword">
                <v-card>
                  <v-card-text>
                    <v-form ref="resetPassword" v-model="resetPasswordValid">
                      <v-text-field
                        class="input-center"
                        label="E-mail"
                        name="email"
                        v-model="email"
                        :rules="[rules.emailRequired, rules.emailValid]"
                        required
                        filled
                        rounded
                      ></v-text-field>
                      <v-btn
                        :disabled="!resetPasswordValid"
                        :dark="resetPasswordValid"
                        color="indigo darken-2"
                        @click="resetPassword"
                      >
                        RESET PASSWORD
                      </v-btn>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>

          <v-card-actions v-if="form == 'signin'">
            <v-row>
              <!-- <v-col>
                <v-btn small dense text @click="form = 'register'">
                  Register New Account
                </v-btn>
              </v-col> -->
              <v-col>
                <v-btn small text @click="form = 'resetPassword'">
                  Reset Password
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions v-if="form == 'resetPassword' || form == 'register'">
            <v-row>
              <v-col>
                <v-btn text @click="form = 'signin'">
                  SIGIN IN
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </div>
      <!-- REGISTER -->
      <Register v-show="form == 'register'" v-on:signIn="form = 'signin'" />
    </v-container>
  </v-container>
</template>

<script>
/* eslint-disable */
import config from "@/config/app";
import { firebaseApp as firebase, dbProfiles } from "@/config/firebase";

export default {
  name: "SignIn",
  route: {
    path: "/sign-in",
    name: "Sign In",
  },
  components: {
    Register: () => import("./Register.vue"),
  },
  data: () => ({
    form: "signin",
    render: true,
    valid: false,
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    errorMessage: null,
    resetPasswordValid: false,
    resetPasswordMessage: {
      show: false,
    },
    password: "",
    checkbox: false,
    passwordShow: false,
    rules: {
      emailRequired: (v) => !!v || "E-mail is required",
      emailValid: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      required: (value) => !!value || "Required.",
      min: (v) => (v && v.length >= 8) || "Min 8 characters",
      emailMatch: () => `The email and password you entered don't match`,
    },
    notification: {
      icon: "mdi-checkbox-marked-circle",
      title: null,
      message: "Test Alert",
      color: "error",
      dark: false,
      show: false,
      default: {
        icon: "mdi-checkbox-marked-circle",
        title: null,
        message: "Test Alert",
        color: "error",
        dark: false,
        show: false,
      },
    },
  }),
  methods: {
    signIn(e) {
      const _this = this;
      firebase
        .auth()
        .signInWithEmailAndPassword(_this.email, _this.password)
        .then((user) => {
          console.log("_signedIn", user);
          _this.$app.user.loggedIn = true;
        })
        .catch(function(error) {
          // Handle Errors here.
          // var errorCode = error.code;
          // var errorMessage = error.message;
          console.log("error", error);
          _this.notification = {
            icon: "mdi-alert-outline",
            title: error.code,
            message: error,
            color: "warning",
            show: true,
            timeout: 2000,
          };
        });
    },
    getUserProfile(uid) {
      //console.log('uid', uid)
      const _this = this;
      const userDefault = config.userDefault;
      dbProfiles
        .where("uid", "==", uid)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            const userProfile = doc.data();
            userProfile["profile_uid"] = doc.id;

            console.log(doc.id, " => ", doc.data());
            console.log("userDefault", userDefault);
            _this.$app.user = Object.assign(userDefault, userProfile);
          });
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
    resetPassword(e) {
      console.log("e", e.srcElement.parentElement.form);
      window.formEvent = e;
      var actionCodeSettings = {
        // After password reset, the user will be give the ability to go back
        // to this page.
        url: "https://dev.atomicmotion.com/npc-connect/",
        handleCodeInApp: false,
      };
      firebase
        .auth()
        .sendPasswordResetEmail(this.email, actionCodeSettings)
        .then(() => {
          // Password reset email sent!
          // ..
          this.form = "signin";
          this.notify({
            icon: "mdi-checkbox-marked-circle",
            title: "Password Reset Link Sent",
            message: `An email has been sent to ${this.email} with a link to reset password.`,
            color: "info",
            dark: true,
            show: true,
            time: 3000, // time in ms
          }).then((data) => {
            console.log("notify data", data);
          });
        })
        .catch((error) => {
          var errorCode = error.code;
          var errorMessage = error.message;
          // ..
          this.notify({
            icon: "mdi-checkbox-marked-circle",
            title: errorCode,
            message: errorMessage,
            color: "error",
            dark: true,
            show: true,
            time: null, // time in ms
          }).then((data) => {
            console.log("notify data", data);
          });
          console.log(error);
        });
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.siginInForm.reset();
      this.notification = {
        icon: "mdi-checkbox-marked-circle",
        title: null,
        message: "Test Alert",
        color: "error",
        dark: false,
        show: true,
      };
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    keyPress(evtobj) {
      // listens for keypress
      //console.log("keypress", evtobj);

      if (evtobj.keyCode == 83 && evtobj.altKey) {
        // listens for alt+s
        this.stars = !this.stars;
      }
    },
    reRender() {
      this.render = false;
      this.$nextTick(() => (this.render = true));
    },
    notify(notification) {
      // used for notification object
      let notifyObj = {
        icon: "mdi-checkbox-marked-circle",
        title: null,
        message: "Test Alert",
        color: "error",
        dark: false,
        show: true,
        time: null, // time in ms
      };
      return new Promise((res, rej) => {
        this.notification = Object.assign({}, notifyObj, notification);
        console.log(this.notification);
        if (this.notification.time) {
          setTimeout(() => {
            this.notification.show = false;
            res("done");
          }, this.notification.time);
        } else {
          res("done");
        }
      });
    },
  },
  mounted() {
    this.reRender;
  },
  created() {
    document.onkeydown = this.keyPress;
  },
};
</script>

<style lang="scss">
.signin-wrapper {
  background: none !important;
  width: 100%;
  max-width: 400px;

  &.register {
    max-width: 500px;
  }
}

// Fixes Autofill color
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus textarea:-webkit-autofill,
textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 30px rgba(240, 240, 240, 0) inset !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.87);
}
</style>
